/**
 * Price Range Slider Component
 * Handles dual-range price filtering with visual slider interface
 */

class PriceRangeSlider {
  constructor(container) {
    this.container = container;
    this.minSlider = container.querySelector('.price-slider-min');
    this.maxSlider = container.querySelector('.price-slider-max');
    this.rangeTrack = container.querySelector('.price-slider-range');

    this.minInput = document.getElementById(this.minSlider.dataset.targetInput);
    this.maxInput = document.getElementById(this.maxSlider.dataset.targetInput);

    this.rangeMin = parseInt(this.minSlider.min);
    this.rangeMax = parseInt(this.minSlider.max);

    this.init();
  }

  init() {
    this.updateRangeTrack();
    this.bindEvents();
  }

  bindEvents() {
    this.minSlider.addEventListener('input', () => this.handleSliderMinChange());
    this.maxSlider.addEventListener('input', () => this.handleSliderMaxChange());

    if (this.minInput) {
      this.minInput.addEventListener('change', () => this.handleInputMinChange());
    }
    if (this.maxInput) {
      this.maxInput.addEventListener('change', () => this.handleInputMaxChange());
    }
  }

  handleSliderMinChange() {
    let minValue = parseInt(this.minSlider.value);
    const maxValue = parseInt(this.maxSlider.value);

    if (minValue >= maxValue) {
      minValue = maxValue - 1;
      this.minSlider.value = minValue;
    }

    if (this.minInput) this.minInput.value = minValue;
    this.updateRangeTrack();
  }

  handleSliderMaxChange() {
    const minValue = parseInt(this.minSlider.value);
    let maxValue = parseInt(this.maxSlider.value);

    if (maxValue <= minValue) {
      maxValue = minValue + 1;
      this.maxSlider.value = maxValue;
    }

    if (this.maxInput) this.maxInput.value = maxValue;
    this.updateRangeTrack();
  }

  handleInputMinChange() {
    let value = parseInt(this.minInput.value) || 0;
    const maxValue = parseInt(this.maxSlider.value);

    value = Math.max(this.rangeMin, Math.min(value, maxValue - 1));

    this.minInput.value = value;
    this.minSlider.value = value;
    this.updateRangeTrack();
  }

  handleInputMaxChange() {
    let value = parseInt(this.maxInput.value) || this.rangeMax;
    const minValue = parseInt(this.minSlider.value);

    value = Math.max(minValue + 1, Math.min(value, this.rangeMax));

    this.maxInput.value = value;
    this.maxSlider.value = value;
    this.updateRangeTrack();
  }

  updateRangeTrack() {
    const minValue = parseInt(this.minSlider.value);
    const maxValue = parseInt(this.maxSlider.value);

    const minPercent = ((minValue - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;
    const maxPercent = ((maxValue - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;

    if (this.rangeTrack) {
      this.rangeTrack.style.left = minPercent + '%';
      this.rangeTrack.style.width = (maxPercent - minPercent) + '%';
    }
  }
}

// Initialize all price range sliders
document.addEventListener('DOMContentLoaded', () => {
  const sliderContainers = document.querySelectorAll('.price-slider-container');
  sliderContainers.forEach(container => {
    new PriceRangeSlider(container);
  });
});

// Re-initialize when fly-out panel opens (for dynamic content)
document.addEventListener('click', (e) => {
  if (e.target.matches('.js-fly-out-panel-toggle')) {
    // Small delay to ensure panel content is rendered
    setTimeout(() => {
      const sliderContainers = document.querySelectorAll('.price-slider-container');
      sliderContainers.forEach(container => {
        // Check if already initialized
        if (!container.dataset.initialized) {
          new PriceRangeSlider(container);
          container.dataset.initialized = 'true';
        }
      });
    }, 100);
  }
});

export default PriceRangeSlider;
